import React from 'react';
import { IndianRupee, Users, FileText, FileCheck, TrendingUp, TrendingDown } from 'lucide-react';
import styles from './StatsCard.module.css';

const iconMap = {
  IndianRupee,
  Users,
  FileText,
  FileCheck
};

export default function StatsCard({ title, value, change, trend, icon, color, loading }) {
  const Icon = iconMap[icon];

  const parseValue = (val) => {
    if (typeof val !== 'string') return 0;
    // Remove currency symbols, commas, and lakh indicators ('L')
    const numericString = val.replace(/₹|L|,/g, '').trim();
    const number = parseFloat(numericString);
    // If 'L' was present, multiply by 100,000
    if (val.includes('L')) {
      return number * 100000;
    }
    return isNaN(number) ? 0 : number;
  };
  
  const endValue = parseValue(value);
  const isCurrency = value.includes('₹');

  const formatNumber = (n) => {
    if (!isCurrency) return n.toLocaleString('en-IN');
    if (n >= 100000) {
      return `₹${(n / 100000).toFixed(2)} L`;
    }
    return `₹${n.toLocaleString('en-IN')}`;
  };

  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <div className={styles.iconWrapper} style={{ backgroundColor: `${color}15` }}>
          <Icon className={styles.icon} style={{ color }} size={24} />
        </div>
        <div className={styles.trendBadge} style={{ 
          backgroundColor: trend === 'up' ? '#e6f7f0' : '#ffe6e6',
          color: trend === 'up' ? '#059669' : '#dc2626'
        }}>
          {trend === 'up' ? <TrendingUp size={14} /> : <TrendingDown size={14} />}
          <span>{change}</span>
        </div>
      </div>
      
      <div className={styles.content}>
        <div className={styles.value}>
          {loading ? (
            <span>{formatNumber(0)}</span>
          ) : (
            <span>{formatNumber(endValue)}</span>
          )}
        </div>
        <div className={styles.title}>{title}</div>
      </div>
    </div>
  );
}

